import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const GetServiceCaller = async (url) => {
  const headers = {
    accept: "application/json",
    Authorization: "Bearer " + localStorage.getItem("token"),
    "content-type": "application/json",
  };
  try {
    const response = await axios({ method: "get", url: url, headers: headers });
    return response;
  } catch (error) {
    if (error.response.status == 401) {
      localStorage.clear("token");
      localStorage.clear("user");
      window.location.href = "/login?unauthorize=true";
    }
  }
};
// export const PostServiceCaller = async (url, payload, method) => {
//     const headers = {
//         'accept': 'application/json',
//         'Authorization': 'Bearer ' + localStorage.getItem('token'),
//         'content-type': 'application/json'
//     };
//     try {
//         const response = await axios({ method:method, url: url, data: payload, headers: headers });
//         return response;
//     } catch (error) {
//         if (error.response.status == 401) {
//             localStorage.clear('token');
//             localStorage.clear('user');
//             window.location.href = "/login?unauthorize=true";
//         }else if (error.response.status == 400){
//             console.log("error",error);
//             toast.error(error?.message);
//         }
//     }
// }

const showValidationErrors = (data) => {
  if (data?.errors && typeof data.errors === "object") {
    const errorMessages = Object.values(data.errors).flat();
    if (errorMessages.length > 0) {
      errorMessages.forEach((msg) => {
        if (msg && typeof msg === "string") toast.error(msg);
      });
      return;
    }
  }
  if (data?.message) {
    data.message
      .split(".")
      .filter((ele) => ele.trim() !== "")
      .forEach((ele) => toast.error(ele.trim()));
  } else {
    toast.error("An unexpected error occurred.");
  }
};

export const PostServiceCaller = async (url, payload, method) => {
  const headers = {
    accept: "application/json",
    Authorization: "Bearer " + localStorage.getItem("token"),
    "content-type": "application/json",
  };

  try {
    const response = await axios({ method, url, data: payload, headers });
    return response;
  } catch (error) {
    if (error.response) {
      const { status, data } = error.response;
      console.log("Error response:", error.response);
      console.log("Check latest response data", data);

      switch (status) {
        case 401:
          localStorage.clear("token");
          localStorage.clear("user");
          window.location.href = "/login?unauthorize=true";
          break;
        case 422:
        case 400:
        case 404:
          showValidationErrors(data);
          break;
        default:
          toast.error("An unexpected error occurred.");
      }
    } else {
      toast.error("An unexpected error occurred.");
    }
  }
};

// export const PostFormServiceCaller = async (url, payload, method) => {
//     const headers = {
//         'accept': 'application/json',
//         'Authorization': 'Bearer ' + localStorage.getItem('token'),
//         'content-type': 'multipart/form-data',
//     };
//     try {
//         const response = await axios({ method:'post', url: method=='put'?url+'?_method=PUT':url, data: payload, headers: headers });
//         return response;
//     } catch (error) {
//         if (error.response.status == 401) {
//             localStorage.clear('token');
//             localStorage.clear('user');
//             window.location.href = "/login?unauthorize=true";
//         }
//     }

// }
export const PostFormServiceCaller = async (url, payload, method) => {
  const headers = {
    accept: "application/json",
    Authorization: "Bearer " + localStorage.getItem("token"),
    "content-type": "multipart/form-data",
  };

  try {
    const response = await axios({
      method: "post",
      url: method === "put" ? `${url}?_method=PUT` : url,
      data: payload,
      headers: headers,
    });

    // Check for custom API failure response and display toast
    if (response.data.status === "failed" && response.data.message) {
      response.data.message
        .split(".")
        .filter((ele) => ele.trim() !== "") // Ensure no empty strings
        .forEach((ele) => toast.error(ele.trim())); // Display error messages
    }
    return response;

  } catch (error) {
    if (error.response) {
      const { status, data } = error.response;

      switch (status) {
        case 401:
          localStorage.clear("token");
          localStorage.clear("user");
          window.location.href = "/login?unauthorize=true";
          break;

        case 422:
        case 400:
        case 404:
          showValidationErrors(data);
          break;

        default:
          // No manual fallback error message here
          break;
      }
    }

    // Re-throw error to be handled by the calling code, if necessary
    throw error;
  }
};


export const DeleteServiceCaller = async (url, payload, method) => {
  const headers = {
    accept: "application/json",
    Authorization: "Bearer " + localStorage.getItem("token"),
    "content-type": "multipart/form-data",
  };
  try {
    const response = await axios({
      method: method,
      url: url,
      data: payload,
      headers: headers,
    });
    return response;
  } catch (error) {
    if (error.response.status == 401) {
      localStorage.clear("token");
      localStorage.clear("user");
      window.location.href = "/login?unauthorize=true";
    }
  }
};
